import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.css';
import '../../css/SingleRingBuilder/TableGridBuilder.css';

import '@fortawesome/fontawesome-free/css/all.min.css';
import { GlobalProvider } from '../utils/GlobalContext';
import { HologramViewer } from '../utils/HologramViewerContext';
import React from 'react';
import { createRoot } from 'react-dom/client';
import Index from './components/Index';

// Optional: jQuery Ready Check
if (typeof $ !== 'undefined') {
  console.log('jQuery is ready!');
} else {
  console.error('jQuery is not available.');
}

// Initialize React app in a given target element
export function initializeApp(targetId) {
  if (!targetId) {
    console.error(`Target ID is required, but got: ${targetId}`);
    return false;
  }

  if (typeof targetId !== 'string') {
    console.error(`Target ID must be a string, but got type: ${typeof targetId}`);
    return false;
  }

  const rootElement = document.getElementById(targetId);
  if (rootElement) {
    const root = createRoot(rootElement);
    if (!root) {
      console.error('createRoot is not available.');
      return false;
    }

    root.render(
      <GlobalProvider>
        <HologramViewer>
          <Index />
        </HologramViewer>
      </GlobalProvider>
    );
    console.log(`Initialized app for target: ${targetId}`);
    return true;
  } else {
    console.error(`Element with ID '${targetId}' not found.`);
    return false;
  }
}

// Optionally, call the function here to render the app in the default div if needed
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const builderMasterApp = document.getElementById('BuilderMasterApp');
  if (builderMasterApp) {
    initializeApp('BuilderMasterApp');
  } else {
    console.warn('Element with ID "initializeApp" not found.');
  }
}
